module.exports = __webpack_public_path__ + "static/aliwbg-6ca65dce356dea9a747e15b5393f1326.png";